<script>
// import simplebar from "simplebar-vue";
import { mapGetters } from "vuex";
import SideNav from "./side-nav";
import { layoutComputed } from "@/state/helpers";

export default {
  components: { SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  computed: {
    ...layoutComputed,
    ...mapGetters("authfack", [
      "currentEntity",
    ]),
    getTrimmedCompanyName() {
      const { currentEntity } = this;
      if (currentEntity && currentEntity.name)
        return currentEntity.name.length > 16
          ? `${currentEntity.name.slice(0, 16).trim()}...`
          : currentEntity.name;
      return "";
    },
    getCompanyName() {
      return this.currentEntity && this.currentEntity.name
        ? this.currentEntity.name
        : "";
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60
      },
      widthss: this.$store ? this.$store.state.layout.layoutWidth : {} || {},
      isToggled: true,
      isHovered: false,
      savedLang: "en",
      permenantlyExpanded: false
    };
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu(this.isHovered, this.permenantlyExpanded);
      this.isToggled = !this.isToggled;
      this.$emit("setIsToggled", this.isToggled);
      this.permenantlyExpanded = !this.permenantlyExpanded;
      if (!this.permenantlyExpanded) {
        localStorage.removeItem("permenantlyExpanded");
      } else {
        localStorage.setItem("permenantlyExpanded", true);
      }
      localStorage.setItem("isToggled", this.isToggled);

    },
    setIsHovered(isHovered) {
      this.isHovered = isHovered;
      // console.log('contains', document.body.classList.contains('vertical-collpsed'), this.permenantlyExpanded);
      // if (isHovered && !this.permenantlyExpanded) this.$parent.toggleMenu();
      if (isHovered && document.body.classList.contains('vertical-collpsed')) {
        // setTimeout(() => {
          document.body.classList.remove("vertical-collpsed");
        // }, 300);
      } else if (!isHovered && !document.body.classList.contains('vertical-collpsed') && !this.permenantlyExpanded) {
          // setTimeout(() => {
            document.body.classList.add("vertical-collpsed");
        // }, 300);
      }
      // 
    }
  },
  beforeMount() {
    this.savedLang = localStorage.getItem("language") ?? "en";
    const permenantlyExpanded = localStorage.getItem("permenantlyExpanded");
    if (!permenantlyExpanded) {
      this.permenantlyExpanded = false;
      document.body.classList.add("vertical-collpsed");
      this.isToggled = true;
      this.$emit("setIsToggled", this.isToggled);
    } else {
      this.permenantlyExpanded = true;
        document.body.classList.remove("vertical-collpsed");
      this.isToggled = false;
      this.$emit("setIsToggled", this.isToggled);
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-sidebar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      }
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      }
    },
    isCondensed: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.sidenav.$el.classList.remove('ps');
          })
        }
      }
    }
  }
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu" @mouseover="setIsHovered(true)" @mouseleave="setIsHovered(false)"
  :class="{'menu-colored': isHovered && !permenantlyExpanded }" :style="{ zIndex: isHovered ? '6 !important' : '1 !important' }">
    <div class="scroller-side-menu">
      <div class="side-company-name d-flex align-items-center justify-content-between">
        <div class="long-company-name">
          <div
          v-if="getCompanyName"
        class="company-name"
        v-b-tooltip
        id="companyName"
      >
      {{ getTrimmedCompanyName }}
        
      </div>
      <b-tooltip
      placement="bottom"
        id="company-tooltip"
        v-if="getCompanyName && getCompanyName.length > 16 && permenantlyExpanded"
        target="companyName"
        triggers="hover"
      >
      <span style="width: 180px;">{{ getCompanyName }}</span>
      </b-tooltip>
        </div>
        
        <button
            id="vertical-menu-btn"
            type="button"
            class=" header-item-side"
            @click="toggleMenu"
          >
          <svg style="margin-inline-end: 0px!important;" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.15385 0C0.516552 0 0 0.559598 0 1.25C0 1.9404 0.516552 2.5 1.15385 2.5H16.8462C17.4834 2.5 18 1.9404 18 1.25C18 0.559598 17.4834 0 16.8462 0H1.15385ZM1.15385 5.75C0.516552 5.75 0 6.3096 0 7C0 7.6904 0.516552 8.25 1.15385 8.25H16.8462C17.4834 8.25 18 7.6904 18 7C18 6.3096 17.4834 5.75 16.8462 5.75H1.15385ZM1.15385 11.5C0.516552 11.5 0 12.0596 0 12.75C0 13.4404 0.516552 14 1.15385 14H16.8462C17.4834 14 18 13.4404 18 12.75C18 12.0596 17.4834 11.5 16.8462 11.5H1.15385Z" fill="#103F5E"/>
            </svg>
            
          </button>
      </div>
    
      <div class="h-line-company" v-if="getCompanyName"></div>
    </div>

    <div class="top-space" style="height: 24px;"></div>

    <perfect-scrollbar v-if="!isCondensed" :settings="settings" class="h-1003" :class="{'isToggled': isToggled, 'ar-layout': savedLang === 'ar', 'en-layout': savedLang === 'en'}" style="height: 100%;">
      <SideNav @setIsHovered="setIsHovered"/>
    </perfect-scrollbar>

    <perfect-scrollbar ref="sidenav" v-else class="h-1003" :class="{'isToggled': isToggled, 'ar-layout': savedLang === 'ar', 'en-layout': savedLang === 'en'}">
      <SideNav @setIsHovered="setIsHovered"/>
    </perfect-scrollbar>

    <div class="bottom-space" style="height: 30px;"></div>
  </div>
  <!-- Left Sidebar End -->
</template>

<style lang="scss">
.h-1003 {
  position: relative;
}
.ps__rail-y {
  right: unset !important;
  inset-inline-end: 0 !important;
  background-color: rgba(209, 209, 209, 1) !important;
  border-radius: 8px;
  width: 9px !important;
}
.menu-colored {
  background: #103F5EE0 !important;
  #sidebar-menu ul li a, .active-list-item .has-arrow:after, .active-list-item span, .active-list-item .active-sub-item, .company-name {
    color: white !important;
  }
  #sidebar-menu ul li a .suchicon, #sidebar-menu ul li a .suchicon path, .header-item-side svg path {
    fill: white !important;
  }
  .active-list-item svg > path {
    fill: white !important;
  }
  .ps__thumb-y {
    background-color: #fff !important;
  }
  .ps--active-y > .ps__rail-y {
    background: rgba(255, 255, 255, 0.3) !important;
    width: 9px;
    border-radius: 8px;
  }
}
// .menu-colored .ps__rail-y {
//       top: 80px !important;
//     }
#vertical-menu-btn {
  padding-inline-end: 16px;
}
.vertical-collpsed #vertical-menu-btn {
  margin: auto;
  padding-inline-end: 0;
  padding-bottom: 24px;
  padding-top: 24px;
}

body:not(.vertical-collpsed) {
  #side-menu > li:last-child > a {
    padding-bottom: 16px !important;
  }
  .sub-menu-hr {
    display: none;
  }
  .long-company-name, .side-company-name, .scroller-side-menu {
    height: 62px;
  }

  ul.sub-menu li a {
    margin-top: 32px !important;
    margin-inline-end: 24px !important;
    margin-bottom: 0 !important;
    margin-inline-start: 64px !important;
  }

  div#companyName {
    height: 12px;
    line-height: 12px;
    margin-top: 25.5px !important;
    margin-inline-end: 15px !important;
    margin-bottom: 25.5px !important;
    margin-inline-start: 24px !important;
    width: 159px !important;
    letter-spacing: normal;
  }
}

.company-name {
  width: 156px !important;
  margin-top: 24px;
  margin-inline-end: 0;
  margin-bottom: 24px;
  margin-inline-start: 24px;
  font-weight: 700;
  font-size: 15px;
  line-height: 23px;
  align-items: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #103f5e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vertical-collpsed .company-name,
.vertical-collpsed .h-line-company {
  display: none;
}

.h-line-company {
  width: 100%;
  height: 1px;
  background-color: #EBEBEB;
  opacity: 1;
}
#layout-wrapper {
  margin-top: 24px;
}
.vertical-menu{
  // overflow: auto;
  // overflow-x: auto;
  top: 129px !important;
  margin-inline-start:24px;
  margin-bottom:24px;
  width: 233px !important;
  // inset-inline-end: 500px;
  // height: 747px!important;
  border-radius: 8px;
  // height: 75vh !important;
  // height: max-content !important;
  height: calc(100vh - 156px) !important;
    // overflow: hidden;
    .ps, .h-1003 {
      max-height: calc(100vh - 240px);
      overflow: hidden;
    }
    

    // .h-1003>#side-menu li:hover {
    //   overflow: visible !important; /* Change overflow when li is hovered */
    //   background-color: red;
    // }
    
    .ps__rail-y:hover {
      opacity: 1 !important;
      width: 15px !important;
      .ps__thumb-y {
        // width: 6px !important;
        background-color: #787878;
        // inset-inline-end: 1px !important;
        border-radius: 8px;
        // height: 230px !important;
        // height: calc(100% - 253px) !important;
      }
    }
    .ps:hover > .ps__rail-x, .ps:hover > .ps__rail-y, .ps--focus > .ps__rail-x, .ps--focus > .ps__rail-y, .ps--scrolling-x > .ps__rail-x, .ps--scrolling-y > .ps__rail-y {
      opacity: 1;
    }
}
.vertical-collpsed {
  #side-menu > li:last-child > a {
    padding-bottom: 30px !important;
  }
  #sidebar-menu ul li a:hover {
    font-weight: 700 !important;
  }
  .sub-menu-hr {
    width: 100%;
    border-top: 1px solid #EBEBEB;
    margin-top: 0;
  }
  .user-settings:hover {
    ul {
      width: 189px !important;
    }
    a {
      width: 240px !important;
      border-radius: 0 6px 0 0 !important;
    }
  }

  .reporting:hover {
    ul {
      width: 136px !important;
    }
    a {
      width: 187px !important;
      border-radius: 0 6px 0 0 !important;
    }
  }

  ul.sub-menu li a {
    margin-top: 24px !important;
    margin-inline-end: 0 !important;
    margin-bottom: 16px !important;
    margin-inline-start: 16px !important;
    font-size: 13px;
    height: 10px;
    // margin: unset !important;
    width: auto !important;
  }
  // div#sidebar-menu::-webkit-scrollbar-track {
//     background-color: #D1D1D1;
//     border-radius: 8px;
// }

// div#sidebar-menu::-webkit-scrollbar-thumb {
//     background-color: #787878;
//     border-radius: 8px;
// }
// div#sidebar-menu::-webkit-scrollbar {
//     width: 8px;
//     position: absolute;
//     inset-inline-start: 75px;
// }
  .top-space {
    width: 75px;
    background: white;
  }
  .bottom-space {
    display: none;
  }
  .ps__rail-y {
    inset-inline-start: 60px;
    right: unset !important;
    // top: 80px !important;
    // height: 500px !important;
  }
  .ar-layout .ps__rail-y {
    inset-inline-end: 209px !important;
  }
  .en-layout .ps__rail-y {
    inset-inline-end: 209px !important;
  }

  .scroller-side-menu {
    background: white;
    width: 75px;
    border-start-end-radius: 8px;
    border-start-start-radius: 8px;
  }
  .vertical-menu {
    width: 75px !important;
    box-shadow: none !important;
    #side-menu {
      width: 75px;
      // margin-inline-start: -5px;
      background: white;
      border-end-end-radius: 8px;
      border-end-start-radius: 8px;
      height: 747px;
    }
    // #sidebar-menu {
    //   height: 500px;
    // overflow-y: scroll;
    // overflow-x: hidden;
    // }
    
    background: transparent !important;
    // height: 622px !important;
    overflow-y: hidden;

  }
    .h-1003 {
      max-height: calc(100vh - 238px) !important;
    }
    // .ps__rail-y {
    // top: 25px !important;
    // max-height: calc(100vh - 220px) !important;
    // }
    .ps__thumb-y {
      right: unset !important;
      inset-inline-end: 2px !important;
    }
  }
#sidebar-menu {
//   ul.sub-menu.mm-collapse {
//     padding-inline-start: 55px !important;
//     a {
//       padding: 0px 0px !important;
     
//       width: 133px!important;
//   }
// }
ul li a{
font-weight: 500;
font-size: 14px!important;
line-height: 15px!important;
display: flex!important;
align-items: center!important;
letter-spacing: normal !important;
color: #787878;
// z-index: 1;
// padding: 16px 24px!important;
height: 24px;
    margin-top: 32px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 24px;
    padding: unset !important;
}
#side-menu > li:first-child > a {
  margin-top: 0 !important;
}
// ul li:nth-child(3) > a p, ul li:nth-child(8) > a p {
//   line-height: 22px !important;
//   height: 32px !important;
//   -webkit-box-align: center;
//   -ms-flex-align: center;
//   align-items: center;
//   display: -webkit-box;
// }

}

a.side-nav-link-ref.router-link-exact-active.router-link-active.active span {
font-weight: 700!important;
font-size: 14px!important;
line-height: 28px!important;

align-items: center!important;
letter-spacing: 0.5px!important;

color: #103F5E!important;
}
a.is-parent.has-arrow.mm-active.mm-collapsed span {
font-weight: 700!important;
font-size: 14px!important;
line-height: 28px!important;

align-items: center!important;
letter-spacing: 0.5px!important;

color: #103F5E!important; 
}
a.is-parent.has-arrow.mm-active span {
font-weight: 700!important;
font-size: 14px!important;
line-height: 28px!important;

align-items: center!important;
letter-spacing: 0.5px!important;

color: #103F5E!important; 
}
#sidebar-menu ul li ul.sub-menu{
 
a.side-nav-link-ref.router-link-exact-active.router-link-active.active {
  display: flex;
font-style: normal!important;
font-weight: 400!important;
font-size: 14px!important;
line-height: 28px!important;


letter-spacing: 0.5px;

color: #103F5E!important;
}
span{
  line-height: 10px!important;
}
li a ul.sub-menu li a p.sub-side-menu-label {
  height: 10px;
  line-height: 10px;
}
}

</style>